/*
export default function initMobileMenu() {
    "use strict";

    const btnOpen = document.querySelector('.header__mobile--btnOpen');
    const svgOpen = document.querySelector('.svgOpen');
    const svgClose = document.querySelector('.svgClose');
    const mobileContent = document.querySelector('#level_0.header__mobile--content');
    const header = document.querySelector('header.header__mobile'); // Seleziona l'header
    const body = document.body; // Riferimento al body

    if (!btnOpen || !svgOpen || !svgClose || !mobileContent || !header) {
        console.error('Elementi del menu mobile mancanti');
        return;
    }

    btnOpen.addEventListener('click', () => {
        // Alterna visibilità delle icone
        svgOpen.classList.toggle('d-none');
        svgClose.classList.toggle('d-none');

        // Anima l'icona svgClose con una rotazione
        if (!svgClose.classList.contains('d-none')) {
            svgClose.style.transform = 'rotate(0deg)';
            svgClose.style.transition = 'transform 0.3s ease-in-out';
            requestAnimationFrame(() => {
                svgClose.style.transform = 'rotate(90deg)';
            });
        }

        // Mostra o nasconde il contenitore del menu mobile
        mobileContent.classList.toggle('active');

        // Aggiungi/rimuovi la classe light all'header
        if (mobileContent.classList.contains('active')) {
            header.classList.add('light');
            body.style.overflow = 'hidden';
        } else {
            header.classList.remove('light');
            body.style.overflow = '';
        }
    });

}

/!*export  function initMultiLevelMenu() {
    const menuContainer = document.querySelector('.menu-container');
    const submenuContainer = document.querySelector('.submenu-container');
    const submenuTitle = document.querySelector('.submenu-title');
    const submenuList = submenuContainer.querySelector('.submenu');
    const backButton = submenuContainer.querySelector('.back-button');
    const menuLinksWithChildren = document.querySelectorAll('.menu-toggle');

    const history = []; // Per tracciare la cronologia dei livelli

    // Funzione per aprire un sotto menu
    const openSubMenu = (parent, subMenu) => {
        // Salva lo stato corrente nella cronologia
        history.push({
            title: submenuTitle.textContent,
            content: submenuList.innerHTML,
        });

        // Mostra il sotto menu
        submenuList.innerHTML = subMenu.innerHTML;
        submenuTitle.textContent = parent.querySelector('.menu-link').textContent;

        // Nasconde il menu principale e mostra il contenitore del sotto menu
        menuContainer.style.display = 'none';
        submenuContainer.style.display = 'block';
    };

    // Funzione per chiudere un sotto menu e tornare al livello precedente
    const closeSubMenu = () => {
        if (history.length > 0) {
            const lastState = history.pop();
            submenuTitle.textContent = lastState.title;
            submenuList.innerHTML = lastState.content;

            if (history.length === 0) {
                submenuContainer.style.display = 'none';
                menuContainer.style.display = 'block';
            }
        }
    };

    // Event listener per i bottoni che aprono i sotto menu
    menuLinksWithChildren.forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const parent = button.closest('.menu-item');
            const subMenu = parent.querySelector('.sub-menu');

            if (subMenu) {
                openSubMenu(parent, subMenu);
            }
        });
    });

    // Event listener per il bottone "indietro"
    backButton.addEventListener('click', closeSubMenu);

    // Nascondi tutti i sotto menu inizialmente
    submenuContainer.style.display = 'none';
}*!/
*/
function bindMenuToggle() {
    const btnOpen = document.querySelector('.header__mobile--btnOpen');
    const svgOpen = document.querySelector('.svgOpen');
    const svgClose = document.querySelector('.svgClose');
    const mobileContent = document.querySelector('#level_0.header__mobile--content');
    const header = document.querySelector('header.header__mobile');
    const body = document.body;
    const wrapper = document.querySelector('.header__mobile--wrapper');



    if (!btnOpen || !svgOpen || !svgClose || !mobileContent || !header) {
        console.error('Elementi del menu mobile mancanti');
        return;
    }

    btnOpen.addEventListener('click', () => {
        svgOpen.classList.toggle('d-none');
        svgClose.classList.toggle('d-none');

        if (!svgClose.classList.contains('d-none')) {
            svgClose.style.transform = 'rotate(0deg)';
            svgClose.style.transition = 'transform 0.3s ease-in-out';
            requestAnimationFrame(() => {
                svgClose.style.transform = 'rotate(90deg)';
            });
        }

        if (wrapper && wrapper.classList.contains('border-bottom')) {
            wrapper.classList.remove('border-bottom');
        }

        mobileContent.classList.toggle('active');

        if (mobileContent.classList.contains('active')) {
            header.classList.add('light');
            body.style.overflow = 'hidden';
        } else {
            header.classList.remove('light');
            body.style.overflow = '';
        }
    });
}

window.bindMenuToggle = bindMenuToggle;
export default function initMobileMenu() {
    "use strict";
    bindMenuToggle(); // ← chiamiamo la prima volta
}